import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const WallboxCheck: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m570 660h-188.46v-30h158.46v-435c0-24.81-16.05-45-35.77-45h-264.23v330h-30v-360h294.23c36.27 0 65.77 33.65 65.77 75z' />
    <path d='m480 240h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m389.79 600c-49.63 0-90-40.37-90-90s40.37-90 90-90 90 40.37 90 90-40.37 90-90 90zm0-150c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60z' />
    <path d='m151.22 674.95 6.78 9.05c2.95 3.93 7.45 6 12.01 6 3.13 0 6.29-.98 8.99-3 2.59-1.94 6-7 6-7l85-156.44c-14.6-7.82-32.79-2.33-40.61 12.28l-60.52 112.65-44.91-59.43c-13.23 9.97-15.86 28.78-5.88 42' />
    <path d='m240 660h165s0-30 0-30h-135c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

WallboxCheck.displayName = 'WallboxCheck';

export default WallboxCheck;
